module.exports = __webpack_public_path__ + "static/wastrilith-2211d79c3dded6fff38bace88a5818f2.png";